import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { BiFilterAlt } from "react-icons/bi";
import { sliceWords } from "../../../../utils/functions";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";

import downloadExcel from "./downloadExcel";

export default function LisDataVisaReport({
  reportData = [],
  filteredReportData = [],
  setFilteredReportData,
  titles = [
    "Sl No.",
    "Project",
    "VRF No.",
    "Status",
    "Authorized Date",
    "Visa Provider",
    "Country",
    "Job Position",
    "VISA Profession",
    "Total VISA",
    "Total Candidates",
    "VISA Stamped",
    "Deployed",
    "Yet to Deploy",
    "Balance VISA",
  ],
  allCountry,
  allJobPosition,
  allProjects,
  allVisaProfession,
  allVisaProviders,
}) {
  const [loading, setLoading] = useState(true);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    currentList,
    setResetPagination,
  } = useSearchPagination(filteredReportData ? filteredReportData : []);

  const [allConditions, setAllConditions] = useState({
    status: "All",
    project_id: "All",
    company_id: "All",
    job_position_id: "All",
    nationality_id: "All",
    visa_profession_id: "All",
  });

  useEffect(() => {
    setFilteredReportData((filteredData) =>
      reportData.filter(
        (data) =>
          (allConditions.status != "All"
            ? data?.status == allConditions.status
            : data?.status) &&
          (allConditions.project_id != "All"
            ? data?.project_id == allConditions.project_id
            : data?.project_id) &&
          (allConditions.company_id != "All"
            ? data?.company_id == allConditions.company_id
            : data?.company_id) &&
          (allConditions.job_position_id != "All"
            ? data?.job_position_id == allConditions.job_position_id
            : data?.job_position_id) &&
          (allConditions.nationality_id != "All"
            ? data?.nationality_id == allConditions.nationality_id
            : data?.nationality_id) &&
          (allConditions.visa_profession_id != "All"
            ? data?.visa_profession_id == allConditions.visa_profession_id
            : data?.visa_profession_id)
      )
    );
    setResetPagination((prev) => !prev);
  }, [allConditions]);

  const filteringOptions = [
    {
      array: ["Issued", "Not Issued"],
      keyName: "status",
      title: "Status",
    },
    {
      array: allProjects,
      keyName: "project_id",
      title: "Project",
    },
    {
      array: allCountry,
      keyName: "nationality_id",
      title: "Country",
    },
    {
      array: allJobPosition,
      keyName: "job_position_id",
      title: "Job Position",
    },
    {
      array: allVisaProviders,
      keyName: "company_id",
      title: "Visa Provider",
    },
    {
      array: allVisaProfession,
      keyName: "visa_profession_id",
      title: "Visa Profession",
    },
  ];

  const [filterView, setFilterView] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setDownloadLoading(false);
    }, 2500);
  }, [downloadLoading]);
  return (
    <>
      <div
        className={`max-w-xs uppercase mt-5 gap-4 flex flex-col py-5 fixed -top-6 right-0 bg-white/95 min-h-screen h-screen z-50 shadow-lg transition-all ${
          !filterView
            ? "w-0 overflow-hidden px-0"
            : "w-[20rem] overflow-auto px-5"
        }`}
      >
        <h1 className="text-xl font-semibold uppercase">Filter</h1>
        {filteringOptions.map((option) => (
          <FilterItem
            key={option.keyName}
            filterArray={option.array}
            title={option.title}
            keyName={option.keyName}
            allConditions={allConditions}
            setAllConditions={setAllConditions}
          />
        ))}
        <div className="my-3 flex gap-3 justify-evenly">
          <button
            className="p-1 px-4 rounded-md uppercase ring-1 ring-slate-300"
            onClick={() => setFilterView(false)}
          >
            Close
          </button>
          <button
            className="p-1 px-4 rounded-md uppercase ring-1 ring-red bg-red text-white"
            onClick={() => {
              setFilterView(false);
              setAllConditions({
                project_id: "All",
                company_id: "All",
                job_position_id: "All",
                nationality_id: "All",
                visa_profession_id: "All",
                status: "All",
              });
            }}
          >
            Reset
          </button>
        </div>
      </div>
      <div className="pt-2  uppercase">
        <div className="flex w-full flex-wrap sm:flex-nowrap my-1 gap-3 items-center">
          <div className="flex md:flex-nowrap flex-wrap items-center gap-3">
            <Search
              searchKey={[
                "project.name",
                "vrf_no",
                "status",
                "authorized_date",
                "company.name",
                "nationality.name",
                "job_position.name",
                "visa_profession.name",
                "visa_quantity",
              ]}
            />
            <button
              className="p-2 px-4 uppercase rounded-md bg-blue text-white min-w-fit h-fit  text-sm flex items-center gap-2"
              onClick={() => {
                setDownloadLoading(true);
                downloadExcel(filteredReportData);
              }}
              disabled={downloadLoading}
            >
              <p>Download</p>
              {downloadLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
          <div className="min-w-fit ml-auto   flex flex-col gap-2 items-end">
            <button
              className="flex uppercase gap-2 p-1 px-4 text-white bg-blue/90 rounded-md items-center "
              onClick={() => setFilterView(true)}
            >
              <BiFilterAlt /> Filter
            </button>
            <p className="text-xs w-full text-right m-1">{`Slide / scroll to right >`}</p>
          </div>
        </div>
        <div
          className={`grid justify-items-center uppercase grid-cols-table-visa-report auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {filteredReportData?.length <= 0 && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-full">
              <p>No Data Found</p>
            </div>
          )}
          <NoDataFound />

          {currentList.map((data, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>{data.project?.name}</p>
              <p>{data.vrf_no}</p>
              <p>{data.status}</p>
              <p>{data.authorized_date}</p>
              <p>{data.company?.name}</p>
              <p>{data.nationality?.name}</p>
              <p>{data.job_position?.name}</p>
              <p>{data.visa_profession?.name}</p>
              <p>{data.visa_quantity}</p>
              <p>{data.candidate?.length}</p>
              <p>
                {
                  data.candidate?.filter(
                    (candidate) => candidate?.visa_stamped == "YES"
                  )?.length
                }
              </p>
              <p>
                {
                  data.candidate?.filter(
                    (candidate) => candidate?.visa_deployed == "YES"
                  )?.length
                }
              </p>
              <p>
                {
                  data.candidate?.filter(
                    (candidate) => candidate?.visa_deployed == "NO"
                  )?.length
                }
              </p>
              <p>{data.visa_quantity - data.candidate?.length}</p>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-full `}
              />
            </React.Fragment>
          ))}
        </div>
        <Pagination />
      </div>
    </>
  );
}

const FilterItem = ({
  filterArray = [],
  title,
  keyName,
  allConditions,
  setAllConditions,
}) => {
  const handleFilter = (keyName, value) => {
    setAllConditions((condition) => ({ ...condition, [keyName]: value }));
  };
  return (
    <div className="flex flex-col max-w-xs-ultra w-full gap-1">
      <label className="text-xs">{title}</label>
      <select
        className="select uppercase select-sm select-bordered"
        defaultValue={"All"}
        value={allConditions[keyName]}
        onChange={(e) => handleFilter(keyName, e.target.value)}
      >
        <option value="All">All</option>

        {keyName == "status"
          ? filterArray.map((data) => (
              <option key={data} value={data}>
                {data}
              </option>
            ))
          : filterArray.map((data) => (
              <option key={data.id} value={data.id}>
                {data?.name}
              </option>
            ))}
      </select>
    </div>
  );
};
